const reviews_swiper = new Swiper('.review_slides-initialize', {
  // If we need pagination
  pagination: {
    el: '.review_slides-initialize .swiper-pagination',
    clickable: true
  },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
  slidesPerView: 3,
  slidesPerGroup: 1,
  allowTouchMove: true,
  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
      }
    },
    540: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 20,
      freeMode: true
    }
  }
});



  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // },


